import React from 'react';
import { Spin, SpinProps } from 'antd';
import classNames from 'classnames';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
type Props = SpinProps & {
  overlay?: boolean;
  visible?: boolean;
  overlayClassName?: any;
};

const StyledOverlay = styled('div', {
  shouldForwardProp(propName) {
    return !['overlay', 'visible'].includes(propName);
  }
})<{ overlay?: boolean; visible?: boolean }>`
  visibility: ${(prop) => (prop.visible ? 'visible' : 'hidden')};
  text-align: center;
  margin: 48px auto;

  ${(prop) =>
    prop.overlay
      ? css`
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 9999;
          background: rgba(0, 0, 0, 0.3);
        `
      : ''}
`;

export const Spinner: React.FC<Props> = ({
  overlay,
  visible,
  overlayClassName,
  ...props
}) => {
  return (
    <StyledOverlay
      visible={visible}
      overlay={overlay}
      className={classNames(overlayClassName)}
    >
      <Spin size={overlay ? 'large' : 'default'} {...props}></Spin>
    </StyledOverlay>
  );
};
